import React, { ReactNode, useState } from 'react'
import { MenuItem } from '../../../../components'
import { IServiceInfo, IStop } from '../../../../models'
import { StopLine } from '../StopLine'
import StyledSection from './styles'

interface IProps {
  serviceInfo: IServiceInfo
  onClickStop: (stop: IStop) => void
  destinationBusStops: IStop[]
  pickedServiceInfo: number | null
  pickedOriginBusStop?: IStop
  pickedDestinationBusStop?: IStop
  moreThanOneServiceInfo?: boolean
}

export const ServiceLine: React.FC<IProps> =
  ({ serviceInfo, onClickStop, destinationBusStops, pickedServiceInfo, pickedOriginBusStop, pickedDestinationBusStop, moreThanOneServiceInfo }) => {
  const [displayStops, setDisplayStops] = useState(true)
  const [forwardDirection, setForwardDirection] = useState(true)
  const stops = displayStops
    ? serviceInfo.stops
        .filter((s: IStop) => forwardDirection ? (s.direction == 0 || s.direction == null) : (s.direction == 1 || s.direction == null))
        .sort((a, b) => a.code - b.code)
        .map(stop => (
          <StopLine
            key={ `${serviceInfo.id}_${stop.id}_${stop.direction}` }
            serviceInfo={ serviceInfo }
            stop={ stop }
            onPress={ (stopPressed: IStop) => onClickStop(stopPressed) }
            destinationBusStops={ destinationBusStops }
            pickedServiceInfo={ pickedServiceInfo }
            pickedOriginBusStop={ pickedOriginBusStop }
            pickedDestinationBusStop={ pickedDestinationBusStop }
            restrictedOrigins={ serviceInfo.restrictedOrigins }
          />
        ))
    : null

    return (
      <StyledSection>
        { moreThanOneServiceInfo &&
          <MenuItem
            label={ serviceInfo.name }
            onClick={ () => setDisplayStops(current => !current) }
            containerStyles={ { borderBottomWidth: 0, fontWeight: 'bold' } }
            icon={ displayStops ? 'down' : 'arrowRight' }
            frontIcon={ serviceInfo.alterationMessages.length > 0 ? 'alteration' : undefined }
          />
        }
        { stops }
      </StyledSection>
    )
}
